import { render, staticRenderFns } from "./FormulaTemplate.vue?vue&type=template&id=5a9e74fd&scoped=true&"
import script from "./FormulaTemplate.vue?vue&type=script&lang=js&"
export * from "./FormulaTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9e74fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a9e74fd')) {
      api.createRecord('5a9e74fd', component.options)
    } else {
      api.reload('5a9e74fd', component.options)
    }
    module.hot.accept("./FormulaTemplate.vue?vue&type=template&id=5a9e74fd&scoped=true&", function () {
      api.rerender('5a9e74fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/FormulaTemplate.vue"
export default component.exports